// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import LazyImagePresentationPropsDefault from "@insite/mobius/LazyImage/presentationProps";
import { xBaseTheme } from "@steiner/XDL/types";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...LazyImagePresentationPropsDefault,
        height: "auto",
        mergeCss: true,
        css: css`
            img {
                width: auto;
                height: auto;
                max-height: 100%;
                max-width: 100%;
                object-fit: contain;
            }
        `,
    },
} as xBaseTheme["lazyImage"];
